import wrapWithProvider from "./wrap-with-provider"
import { initBuildUpdateChecker } from "./src/utils/buildUpdateChecker"

export const wrapRootElement = wrapWithProvider

// Redirections frontend (équivalent des 301 Apache, appliquées aussi lors de la
// navigation SPA Gatsby — un clic de menu ne repasse pas par Apache).
// Le code de gatsby-browser est compilé dans le bundle JS de l'app, toujours
// reconstruit : contrairement aux pages, il ne dépend pas du cache Gatsby.
const REDIRECTS = {
  "/sortir-a-roubaix": "/agenda/"
}

const resolveRedirect = (pathname) => {
  if (!pathname) return null
  const normalized = pathname.length > 1 ? pathname.replace(/\/$/, "") : pathname
  return REDIRECTS[normalized] || null
}

export const onClientEntry = () => {
  initBuildUpdateChecker()
  // Accès direct à une URL redirigée (chargement initial).
  if (typeof window !== "undefined") {
    const target = resolveRedirect(window.location.pathname)
    if (target) window.location.replace(target)
  }
}

// Navigation SPA (clic sur un lien de menu) : intercepte avant le rendu de la route.
export const onPreRouteUpdate = ({ location }) => {
  if (typeof window === "undefined" || !location) return
  const target = resolveRedirect(location.pathname)
  if (target) window.location.replace(target)
}

function isElementInViewport (el) {
    var rect = el.getBoundingClientRect();
    return (rect.top > 0)
}

export const shouldUpdateScroll = ({ routerProps: { location } }) => {

    if(location && location.state && location.state.menuNavigation && window.innerWidth >= 1279){
        const pageTemplate = document.querySelector(".menu-page-banner"),
            Level2 = document.querySelector(".submenu-container.level-2 .list-menu"),
            Level1 = document.querySelector(".submenu-container.level-1 .menu-level-1 .list-menu")

        if(Level2 && Level2.lastChild){
            if(!isElementInViewport(Level2.lastChild) && pageTemplate && pageTemplate.offsetTop){
                return [0, pageTemplate.offsetTop]
            }
        }else if (Level1 && Level1.lastChild){
            if(!isElementInViewport(Level1.lastChild) && pageTemplate && pageTemplate.offsetTop){
                return [0, pageTemplate.offsetTop]
            }
        }
        return false
    }
    else
        return true
}